import { BaseEntityModel } from '../core/abstractions/base-entity.model';

export class ReportScheduleModel extends BaseEntityModel {
    reportId: string;
    reportParameters: string;
    reportFormat: string;
    reportValidForDays?: number;
    userId: number;
    shouldReceiveEmailNotification: boolean;
    nextExecutionTime: Date;
    nextExecutionCronSchedule: string;

    constructor(init?: Partial<ReportScheduleModel>) {
        super();
        Object.assign(this, init);
    }
}
